module.exports = __webpack_public_path__ + "img/currencyEle.9a6f2437.svg";